import React, { useEffect, useState } from 'react';
import InputForm from '../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import { Box, CircularProgress, TextField, Typography } from '@mui/material';
import { Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { MonetizationOn, MonetizationOnOutlined, Money, Phone } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import SearchInput from '../../SearchInput';
import CheckBox from '../../CheckBox';
import SearchModal from '../../SearchModal';
import UploadButton from '../../UploadButton';
import File from '../../File';
import COMPTES from '../../../Models/Comptes';
import { Crypter } from '../../../Functions/Security/Crypter';
import axios from 'axios';
import Datas from "../../../Data/Data.json";
import SweetAlert from "sweetalert2";
import CheckboxF from '../../ChexBox';
import IamgeViewer from '../../IamgeViewer';
import RELATION from '../../../Models/Relation';
import RadioBox from '../../Radiox';


let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: "", Choix: 22 }


//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchAgence: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

interface SelectData {
  value: string,
  label: string,
}



function Tab1(props: { form?: any, disabled?: boolean }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  const [check1, setChek1] = useState(false)
  const [check2, setChek2] = useState(false)
  const [check3, setChek3] = useState(false)
  const [check4, setChek4] = useState(false)
  const [check5, setChek5] = useState(false)
  const [check6, setChek6] = useState(false)
  const [IdClient, setIdClient] = useState("")
  const [CompetClients, SetCompetClients] = useState<SelectData[]>([])
  const [loadCompte, setLoadCompte] = useState(false)
  const [numcpt, setNumcpt] = useState("")
  const [image, setImage] = useState<string>()
  const [isTmp, setIsTmp] = useState(false)


  // USER TOKEN
  const authHeader = useAuthHeader()


  let searchCompte: Params = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCLI", Colonne2: "NUMCPT", Colagence: '101', Init: IdClient, Choix: 22 }

  function handleChek() {
    setChek1(props.form.getFieldValue("isPrintAvis"))
    setChek2(props.form.getFieldValue("isPrintRef"))
    setChek3(props.form.getFieldValue("isdeleteOpe"))
    setChek4(props.form.getFieldValue("isValDistanct"))
    setChek5(props.form.getFieldValue("isStaff"))
    setChek6(props.form.getFieldValue("CONNECT"))
  }

  function loadClientCompte() {
    setNumcpt("")
    setLoadCompte(true)
    SetCompetClients([])

    // setCompteEpargne([])
    // setCompteOrdinaire([])
    // setNumcpt("")
    let numcli = props.form.getFieldValue("INDUTI")
    //alert(numcli)
    if (numcli != "") {
      let searchClientComptes: Params = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCLI", Colonne2: "", Init: numcli, Colagence: '101', Choix: 33 }

      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;


            //alert(JSON.stringify(res))
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              //alert(JSON.stringify(datas))

              //alert(datas.length)
              if (datas.length === 0) {
                SweetAlert.fire({ title: "This client don't have accounts", icon: "warning" })
              }
              else {
                const datat: SelectData[] = [];

                datas.map((data: COMPTES) => {
                  //console.log(JSON.stringify(data))
                  //alert(data.IDPLAN.substring(0, 3))

                  datat.push({
                    value: data.NUMCPT,
                    label: data.NUMCPT + " - " + data.NOMCPT,
                  });
                  SetCompetClients(datat);

                  //alert(JSON.stringify(datat))
                })
                //alert(JSON.stringify(datat))
              }
            } else {
              SweetAlert.fire({ title: "Comptes", text: res.Message, icon: "warning" })
            }
          }
          setLoadCompte(false);
        }).catch(() => {
          setLoadCompte(false);
        })

    }
  }

  const handleChangeGompte = (value: string) => {
    setNumcpt(value);
    props.form.setFieldValue("NUMCPT", value)
    //alert(props.form.getFieldValue("NUMCPT"))
  };

  function loadImage(INDUTI: string) {
    //alert(INDUTI)
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetClient,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumcli': Crypter.encrypt(INDUTI)
      }
    };
    axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data));
          //console.log(JSON.stringify(res))
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            if (datas.length != 0) {
              setImage(datas[0].Photo)
            }
          }
        }
      }).catch(() => { })
  }

  useEffect(() => {
    try {
      if(props.form.getFieldValue("INDUTI").length == 0){
        setIsTmp(true)
      }else{        
        setIsTmp(false)
      }
      console.log(props.form.getFieldValue("INDUTI").length)
      if (Crypter.decrypt(localStorage.getItem("numcpt") + "") != "" && Crypter.decrypt(localStorage.getItem("numcpt") + "") != undefined) {
        loadClientCompte()
        loadImage(props.form.getFieldValue("INDUTI"))
        setNumcpt(Crypter.decrypt(localStorage.getItem("numcpt") + "") as string)
        localStorage.setItem("numcpt", "")
      }
    } catch (error) { }
  })

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        SetCompetClients([])
        setNumcpt("")
        setImage("")
        setIsTmp(false)
      }
      localStorage.removeItem(Datas.LocalVariable.reset)
    }
    catch (error) { }

    try {
      let isOkay = localStorage.getItem("load_compte")
      if (isOkay == "1") {
        loadClientCompte()
      }
      localStorage.removeItem("load_compte")
    } catch (error) { }
  }, 0.1);

  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle={"inherit"} display={"flex"}>
          <IamgeViewer image={image} />
          <CheckBox name='tmpUser' notRequired label='Utilisateur temporaire' form={props.form} onClick={(e: any) => { setIsTmp(e.target.checked) }} />
        </Box>
        <Box display={'flex'} fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
          <Box fontStyle="inherit" className='border-left'>
            {/* <SearchModal  width={7} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
            <SearchInput requieredLib dissabledLib={!isTmp} notremove width={7} form={props.form} Titre='Recherche Utilisateur' label='Code' name='CODUTI' Parametre={searchUser} />
            <InputForm width={7} label='Mot de passe' disabled name='MOTPAS' type='password' error='Mot de passe requis' />
            <InputForm width={7} label='Confirmation' disabled name='CONF_MOTPAS' type='password' error='Mot de passe de confirmation requis' />
            <SearchModal width={7} form={props.form} Titre='Recherche Titre' label='Titre' name='CDTITR' Parametre={searchTitre} />
            <InputForm max={"4000-12-31"} label='Date naissance' name='datnais' type='date' error='Date de naissance requise' />
            <InputForm width={7} label='Adresse' name='nomQtier' type='text' error='adresse' />
            <InputForm width={7} icon={<Phone fontSize='small' />} label='Mobile' name='teluti' type='text' error='mobile' />
          </Box>

          <Box fontStyle="inherit" className='border-left'>

            <SearchModal disabled width={7} defaultCode={user.codage} defaultLibelle={user.agence} form={props.form} Titre="Recherche de l'agence" label='Agence' name='CODAGE' Parametre={searchAgence} />
            <SearchModal width={7} form={props.form} Titre='Recherche service' label='Service' name='CODSERV' Parametre={searchService} />
            <SearchModal width={7} form={props.form} Titre='Recherche gestionnaire' label='Gestionnaire' name='CODGES' Parametre={searchGes} />
            <SearchModal defaultCode='O' defaultLibelle='OUVERT' width={7} form={props.form} Titre='Recherche statut' label='Statut' name='STATUT' Parametre={searchStatus} />
            <Box className='bordure1'>
              {!isTmp ? <SearchModal width={7} form={props.form} Titre='Recherche indice' label='Indice' name='INDUTI' handleFunction={loadClientCompte} Parametre={searchIndice} /> : ""}
              {/* <SearchModal  width={7} notRequired form = {props.form}  Titre='Recherche numéro de compte'  label='N° Compte' name='NUMCPT' Parametre={searchCompte}/> */}

              {!isTmp ?
                <>
                  <Box margin={1} fontStyle={'inherit'}>
                    <label htmlFor="">Compte : </label>
                    <Select
                      loading={false}
                      onChange={handleChangeGompte}
                      value={numcpt}
                      size='middle'
                      style={{ width: "80%" }}
                      options={CompetClients}
                      suffixIcon={loadCompte ? <CircularProgress size={"20px"} /> : ''}
                    />
                  </Box>
                  <InputForm  width={7} label='Salaire' icon={<MonetizationOnOutlined fontSize='small' />} name='SALAIR' type='number' error='mobile' />
                </>
                :
                ""
              }
            </Box>
          </Box>
          <Box fontStyle="inherit" className='border-left'>
            <CheckboxF dissabled={!props.disabled} width={21} name={'isPrintAvis'} label={'Impression avis sur opération'} />
            <CheckboxF dissabled={!props.disabled} width={21} name={'isPrintRef'} label={'Impression écriture par ref '} />
            <CheckboxF dissabled={!props.disabled} width={21} name={'isdeleteOpe'} label={'Suppression écriture backoffice'} />
            <CheckboxF dissabled={!props.disabled} width={21} name={'isValDistanct'} label={'Validation litige distant'} />
            <CheckboxF dissabled={!props.disabled} width={21} name={'isStaff'} label={'Membre du staff'} />
            <CheckboxF dissabled={!props.disabled} width={21} name={'CONNECT'} label={'Utilisateur connecté '} />

            {/* <InputForm onChange={(e:any)=>{localStorage.setItem("isPrintAvis", e.target.checked)}} label={'Imperssion avis sur opération'} title={'Imperssion avis sur opération ?'} type={'checkbox'} width={20} />
            <InputForm onChange={(e:any)=>{localStorage.setItem("isPrintRef", e.target.checked)}} label={'Imperssion écriture par ref '} title={'Imperssion écriture par reférence ?'} type={'checkbox'} width={20} />
            <InputForm onChange={(e:any)=>{localStorage.setItem("isdeleteOpe", e.target.checked)}} label={'Supp écriture backoffice'} title={'Suppression écriture backoffice ?'} type={'checkbox'} width={20} />
            <InputForm onChange={(e:any)=>{localStorage.setItem("isValDistanct", e.target.checked)}} label={'Validation litige à distance'} title={'Validation litige à distance ?'} type={'checkbox'} width={20} />
            <InputForm onChange={(e:any)=>{localStorage.setItem("isStaff", e.target.checked)}} label={'Membre du staff'} title={'Membre du staff ?'} type={'checkbox'} width={20} />
            <InputForm onChange={(e:any)=>{localStorage.setItem("CONNECT", e.target.checked)}} label={'Utilisateur connecté ? '} title={'Utilisateur connecté ?'} type={'checkbox'} width={20} /> */}
          </Box>

        </Box>
      </div>
    </div>

  )
}

export default Tab1;